
import { Vue, Component } from 'vue-property-decorator'
import router from '@/router/index'
import { userGadgetList } from '@/plugins/globalStaticDatas'
import { getParameter } from '@/plugins/globals'

@Component
export default class UserProfileGadgets extends Vue {
  userProfileList: any = userGadgetList
  selectedGadget: number = 0

  gotoUserModules(list: any, index: number) {
    this.selectedGadget = index
    router.push(list.name).catch(() => {})
  }
  mounted() {
    this.userProfileList = this.userProfileList.filter((el: any) => el.show)

    if (window.location.hash === '#/') {
      router.replace({ path: '/information' }).catch(() => {})
    }
    if (getParameter('view')) {
      this.selectedGadget = 2
    }
    if (this.$route.name === 'favorites') {
      this.selectedGadget = 2
    }
  }
}
